import { render } from "./CategoryItem.vue?vue&type=template&id=23ec19bd&scoped=true"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"

import "./CategoryItem.vue?vue&type=style&index=0&id=23ec19bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ec19bd"]])

export default __exports__